const ROLL_ILLEGAL_REGEX = /[*;|]/;
const ROLL_VALID_CHARS_REGEX = /^[A-Z0-9 &.\/-]{4,18}$/;

export const rollNumberValidationError =
    'The roll number entered isn\'t valid – please double-check and try again';

export const normaliseBacsRollNumber = (value: string): string =>
    value.toUpperCase().slice(0, 18);

export const validateBacsRollNumber = (value: string): string | null => {
    if (!value || value.trim() === '') {
        return null;
    }

    if (ROLL_ILLEGAL_REGEX.test(value) || !ROLL_VALID_CHARS_REGEX.test(value)) {
        return rollNumberValidationError;
    }

    return null;
};
